import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { Constant } from '../constants/constants';
import { BaseSettingsModel } from '../models/base-settings.model';
import { DataService } from './data.service';
import { DropDownService } from './drop-down.service';
import { EnumService } from './enum.service';
import { StorageService } from './storage.service';
import { ToasterService } from './toaster.service';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains'
  };
  companyLogo : string;
  profilepicture : string;
  isModel : boolean = false;
  URLName : string;

  constructor(
    public data: DataService,
    public dropDown: DropDownService,
    public toast: ToasterService,
    public enums: EnumService,
    public storage: StorageService,
    private http: HttpClient
  ) {
    this.loadBaseSettings();
  }

  confirmDelete(): boolean {
    if (!confirm(Constant.message.deleteConfirmation)) {
      return false;
    }

    return true;
  }

  validForm(fg: UntypedFormGroup, valid: boolean): boolean {
    Object.keys(fg.controls).forEach((controlName: string) => {
      const control = fg.get(controlName);
      if (control instanceof UntypedFormGroup) {
        valid = this.validForm(control, valid);
      } else {
        if (control.errors) {
          control.markAsTouched();
          valid = false;
        }
      }
    });

    return valid;
  }

  public getTimeZone(): string {
    return /\((.*)\)/.exec(new Date().toString())[1];
  }

  public toBoolean(value: any) {
    if (!value) {
      return value;
    }

    if (typeof value === 'string') {
      value = value.trim().toLowerCase();
    }
    switch (value) {
      case true:
      case 'true':
      case 1:
      case '1':
      case 'on':
      case 'yes':
        return true;
      default:
        return false;
    }
  }

  public loadBaseSettings(): void {
    this.http.get<BaseSettingsModel>('assets/base-settings.json').subscribe((settings) => {
      this.storage.setBaseSettings(settings);
    });
  }
}
